import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import EditViewWorkingHours from '../components/WorkingHours/EditViewWorkingHours';
import CalendarSettings from '../components/Settings/Calendar';
import QuickbooksSettings from '../components/Settings/Quickbooks';
import Inventory from '../components/Settings/Inventory';
import SMS from '../components/Settings/SMS';
import ImportData from '../components/Settings/Import';
import CC from '../components/Settings/CC';
import General from '../components/Settings/General';
import Payroll from '../components/Settings/Payroll';

const Settings = () => {
  return (
    <Routes>
      <Route path="/" element={<div></div>} />
      <Route path="/working_hours" element={<EditViewWorkingHours />} />
      <Route path="/calendar" element={<CalendarSettings />} />
      <Route path="/quickbooks" element={<QuickbooksSettings />} />
      <Route path="/inventory/*" element={<Inventory />} />
      <Route path="/sms" element={<SMS />} />
      <Route path="/cc" element={<CC />} />
      <Route path="/import" element={<ImportData />} />
      <Route path="/payroll" element={<Payroll />} />
      <Route path="/general" element={<General />} />
    </Routes>
  )
}

export default Settings;